// The FF2 form input the dashboard deep-links to, so both have to agree on the id.
export const FUNDRAISING_TARGET_FIELD_ID = 'personalFundraising__fundraisingTarget'

export const buildFundraisingTargetUrl = (editUrl) => {
    if (!editUrl) {
        return null
    }
    return `${editUrl.split('#')[0]}#${FUNDRAISING_TARGET_FIELD_ID}`
}
